import { StepIconProps, Stepper } from "@mui/material";
import { GameResultEnum } from "./Service";
import { ArrowLeft, ArrowRight, DrawStep, LossStep, WinStep } from "./Steps";
import { useMemo } from "react";
import { Connector, CustomStep, CustomStepLabel } from "./Steps.styles";

export function TeamHistoryStepper({
    teamHistory: initialTeamHistory,
    reversed,
}: {
    teamHistory:
        | {
              gameResult: GameResultEnum;
          }[]
        | undefined;
    reversed?: boolean;
}) {
    const shorterTeamsHistory = initialTeamHistory?.slice(0, 3);
    const teamHistory = useMemo(
        () => (reversed ? shorterTeamsHistory : shorterTeamsHistory?.reverse()),
        [shorterTeamsHistory],
    );

    if (!teamHistory) {
        return null;
    }
    const activeStep = reversed ? 1 : teamHistory.length - 1;

    return (
        <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<Connector />}
            style={{
                minHeight: "20px",
            }}
        >
            {reversed && (
                <CustomStep>
                    <CustomStepLabel StepIconComponent={ArrowLeft} />
                </CustomStep>
            )}
            {teamHistory.map((label, index) => (
                <CustomStep key={index}>
                    <CustomStepLabel
                        StepIconComponent={(props: StepIconProps) => {
                            if (label.gameResult === GameResultEnum.WIN) {
                                return <WinStep {...props} />;
                            }
                            if (label.gameResult === GameResultEnum.LOSS) {
                                return <LossStep {...props} />;
                            }

                            return <DrawStep {...props} />;
                        }}
                    />
                </CustomStep>
            ))}
            {!reversed && (
                <CustomStep>
                    <CustomStepLabel StepIconComponent={ArrowRight} />
                </CustomStep>
            )}
        </Stepper>
    );
}
